import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Right} from '../../models/right';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {Hierarchy} from '../../models/security/hierarchy';

@Injectable({
  providedIn: 'root'
})
export class RightService extends AbstractModelService<Right> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/right', Right);
  }

  fetchHierarchy(): Observable<Hierarchy> {
    return new Observable<Hierarchy>(subscriber => {
      this.apiClient.get('/right/hierarchy').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(new Hierarchy().deserialize(response.getData()));
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
